import { Customer } from '@squareup/sq-addons-web-sdk';

export type SearchCustomersState = {
  searchValue: string;
  searchResults?: Customer[];
  searchCustomersState: {
    isPending: boolean;
    apiError?: Error;
    validationError?: Error;
  };
};

export const SEARCH_CUSTOMERS = 'SEARCH_CUSTOMERS';
export const SEARCH_CUSTOMERS_FULFILLED = 'SEARCH_CUSTOMERS_FULFILLED';
export const SEARCH_CUSTOMERS_REJECTED = 'SEARCH_CUSTOMERS_REJECTED';
export const CLEAR_SEARCH_CUSTOMERS = 'CLEAR_SEARCH_CUSTOMERS';

export type SearchCustomersAction = {
  type: typeof SEARCH_CUSTOMERS;
  payload: string;
};

export type SearchCustomersFulfilledAction = {
  type: typeof SEARCH_CUSTOMERS_FULFILLED;
  payload: {
    searchResults: Customer[];
  };
};

export type SearchCustomersRejectedAction = {
  type: typeof SEARCH_CUSTOMERS_REJECTED;
  payload: {
    apiError?: Error;
    validationError?: Error;
  };
};

export type ClearSearchCustomersAction = {
  type: typeof CLEAR_SEARCH_CUSTOMERS;
};

export type SearchCustomersActionTypes =
  | SearchCustomersAction
  | SearchCustomersFulfilledAction
  | SearchCustomersRejectedAction
  | ClearSearchCustomersAction;
